import type { FaireProductEntity } from "../../entity_types/product";

export const p_d4ar0wikxd: FaireProductEntity = {
  token: "p_d4ar0wikxd",
  type: "product",
  name: "Puka Shell Hoop Earring",
  brandName: "Jackie Gallagher Designs - Handmade Coastal Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/2ba8aac5b57d23b28cd99abee629a40413aa6d310871e6b4a65f006ed26020bb.jpeg",
  priceDollars: 14.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/0ab82703fc8f3fb64c791bf7e0c8e38e4ea5597547a0293a0a55ba37d799421d.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
